/**
 * Máscaras para placa de veículo.
 * Suporta antigo: AAA-0000 (LLLNNNN) e Mercosul: AAA0A00 (LLLNLNN).
 */

import { PLACA_TAMANHO } from "../../domain/validators/terceiros.constantes.js";
import { sanitizarPlaca } from "../../domain/rules/normalizadores.js";

export { sanitizarPlaca };

/**
 * Sanitiza placa: maiúsculas, só A-Z0-9.
 * @param {*} valor
 * @returns {string}
 */
/**
 * Sanitiza placa para máscara (bloqueia além do limite).
 * @param {*} valor
 * @returns {string}
 */
export function sanitizarPlacaParaMascara(valor) {
  return sanitizarPlaca(valor).slice(0, PLACA_TAMANHO);
}

/**
 * Aplica máscara incremental: AAA-XXXX (insere hífen após 3).
 * Ex: ABC1234 -> ABC-1234 | ABC1D23 -> ABC-1D23
 * @param {*} valor
 * @returns {string}
 */
export function aplicarMascaraPlaca(valor) {
  const raw = sanitizarPlacaParaMascara(valor);
  if (!raw) return "";
  if (raw.length <= 3) return raw;
  return `${raw.slice(0, 3)}-${raw.slice(3, 7)}`;
}

/**
 * Remove máscara.
 * @param {*} valor
 * @returns {string}
 */
export function removerMascaraPlaca(valor) {
  return sanitizarPlaca(valor);
}
